// src/config.js
export const WEDDING_CONFIG = {
  bride: 'Crizza',
  groom: 'Jerwin',
  weddingDate: '2026-01-10T14:00:00',
  venue: {
    name: 'Our lady of the Most Holy Rosary Parish',
    address: 'Rosario, Northern Samar',
    coordinates: {
      lat: 12.5228652,
      lng: 124.424764
    }
  },
  reception: 'Rosario Municipal Covered Court',
  bibleVerse: '"Therefore a man shall leave his father and mother and hold fast to his wife, and the two shall become one flesh. So they are no longer two but one flesh. What therefore God has joined together, let not man separate."',
  bibleReference: 'Mark 10:7-9',
  hashtag: 'CrizzaandJerwinWedding2026',
  colors: {
    primary: "#9C48AA",
    secondary: "#AE7DD3",
    light: "#E0E6EE",
    accent1: "#E1BFD7",
    accent2: "#D799BE"
  },

  images: {
    couple: 'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332387/couple-photo_vxawki.jpg',
    entourage: 'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332389/entourage-photo_gy2jbc.jpg',
    upload: 'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332393/upload-photo_zjdrx4.jpg',
    venue: 'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332398/venue-photo_obwcef.jpg',

    gallery: [
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332419/14_hrouln.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332418/3_slezqp.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332417/17_ricf7h.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332417/15_y3m1lr.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332413/12_dwr9bv.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332407/8_f1apfe.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332404/5_t0dnjp.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332402/7_ru75jp.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332392/24_znlajt.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332387/22_urrmja.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332380/26_hmsudv.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332374/23_c7voom.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332370/19_mxsoec.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332368/25_cy3ole.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332369/20_znmmbd.jpg',
      'https://res.cloudinary.com/dyjdywp2b/image/upload/v1765332366/21_gh32j0.jpg',
    ]
  }
};
